import LabServiceModel from "@/models/LabServiceModel";
import AnalyteCollection from "@/collections/lab/AnalyteCollection";
import ServiceInstructionCollection from "@/collections/lab/ServiceInstructionCollection";
import ServiceQuestionCollection from "@/collections/lab/ServiceQuestionCollection";
import TurnaroundCollection from "@/collections/lab/TurnaroundCollection";

export default class SampleTypeModel extends LabServiceModel {
  modelName() {
    return "sample-type";
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch =
      process.env.VUE_APP_LAB_REPOSITORY_URL +
      "/api/v1/public/" +
      this.modelName() +
      "/{id}";
    return routes;
  }

  defaults() {
    return {
      id: null,
      name: null,
      description: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      analytes: {},
      service_instructions: {},
      service_questions: {},
      turnarounds: {}
    };
  }

  // Attribute mutations.
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      position: Number,
      created_at: String,
      updated_at: String,
      deleted_at: String
    };
  }

  // Attribute validation
  validation() {
    return {};
  }

  icon() {
    return this.getIcon();
  }

  getIcon() {
    switch (this.name) {
      default:
        return "cube";
    }
  }

  getAnalytes() {
    return this.getRelatedCollection(new AnalyteCollection(), "analytes");
  }

  getServiceInstructions() {
    return this.getRelatedCollection(
      new ServiceInstructionCollection(),
      "service_instructions"
    );
  }

  getServiceQuestions() {
    return this.getRelatedCollection(
      new ServiceQuestionCollection(),
      "service_questions"
    );
  }

  getTurnarounds() {
    return this.getRelatedCollection(new TurnaroundCollection(), "turnarounds");
  }
}
